/* MANDARINA REPUBLIC — HOME v6 · interacción */
(function () {
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money = function (cents) { return '$' + (Number(cents || 0) / 100).toFixed(2); };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ─────────── TOAST ─────────── */
  var toastEl = null, toastT = null;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'mrh-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  /* ─────────── HERO · órbita ───────────
     Las imágenes NO se funden: cada una rota entre cuatro puestos
     (centro → derecha → atrás → izquierda → centro). El CSS hace el viaje. */
  function initHero(hero) {
    /* guardia: `boot()` se vuelve a llamar con cada `shopify:section:load` del
       editor y este mismo hero recibía otro juego de listeners cada vez */
    if (hero.__mrhReady) return;
    hero.__mrhReady = true;
    var slides = $$('[data-slide]', hero);
    var copies = $$('[data-copy]', hero);
    var dots = $$('[data-dot]', hero);
    var N = slides.length;
    if (N < 1) return;
    var i = 0, timer = null, locked = false;
    var delay = parseInt(hero.getAttribute('data-autoplay') || '0', 10) * 1000;
    var TRAVEL = 660;

    function paint(n) {
      i = (n + N) % N;
      slides.forEach(function (s, k) {
        var role = 'is-hidden';
        if (k === i) role = 'is-center';
        else if (k === (i + 1) % N) role = 'is-right';
        else if (k === (i - 1 + N) % N) role = 'is-left';
        else if (N > 3 && k === (i + 2) % N) role = 'is-back';
        s.className = 'mrh-hslide ' + role;
      });
      copies.forEach(function (c, k) { c.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === i);
        d.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
      var bg = slides[i].getAttribute('data-bg');
      if (bg) hero.style.setProperty('--slide-bg', bg);
    }

    /* candado: mientras las imágenes viajan no se acepta otro salto */
    function go(n) {
      if (locked) return;
      locked = true;
      setTimeout(function () { locked = false; }, RM ? 0 : TRAVEL);
      paint(n);
      restart();
    }
    function restart() {
      clearInterval(timer);
      if (delay > 0 && !RM && N > 1) timer = setInterval(function () { paint(i + 1); }, delay);
    }

    var prev = $('[data-prev]', hero), next = $('[data-next]', hero);
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });

    /* swipe */
    var x0 = null, y0 = null;
    hero.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? i + 1 : i - 1);
      x0 = null; y0 = null;
    }, { passive: true });

    /* tocar una imagen de los lados la trae al centro */
    slides.forEach(function (s, k) {
      s.addEventListener('click', function () {
        if (s.classList.contains('is-left') || s.classList.contains('is-right')) go(k);
      });
    });

    /* teclado */
    hero.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') go(i - 1);
      if (e.key === 'ArrowRight') go(i + 1);
    });

    /* Pausa al pasar el mouse SOLO por el texto y los controles.
       Antes se escuchaba sobre todo el hero, y desde que el hero ocupa la
       pantalla completa el puntero está casi siempre encima: el carrusel se
       quedaba quieto en escritorio y solo avanzaba con las flechas. */
    [$('.mrh-hero__ui', hero), $('.mrh-hero__controls', hero)].forEach(function (zona) {
      if (!zona) return;
      zona.addEventListener('mouseenter', function () { clearInterval(timer); });
      zona.addEventListener('mouseleave', restart);
    });
    /* y si la pestaña no se ve, no se gasta batería */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) clearInterval(timer); else restart();
    });

    paint(0);
    restart();
  }

  /* ─────────── REVEAL + PARALLAX ─────────── */
  /* La lista de palabras vive afuera a propósito: los listeners de scroll se
     cuelgan UNA sola vez, pero la lista se vuelve a leer en cada `boot()` para
     que una sección recién cargada en el editor también se mueva. */
  var parallaxWords = [];
  var parallaxBound = false;
  function initMotion() {
    var targets = $$('.mrh-reveal');
    if ('IntersectionObserver' in window && !RM) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
      targets.forEach(function (t) { io.observe(t); });
    } else {
      targets.forEach(function (t) { t.classList.add('is-in'); });
    }

    if (RM) return;
    parallaxWords = $$('[data-parallax]');
    if (!parallaxWords.length || parallaxBound) return;
    parallaxBound = true;
    var ticking = false;
    function frame() {
      var vh = window.innerHeight;
      parallaxWords.forEach(function (w) {
        var host = w.parentElement;
        var r = host.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var amt = parseFloat(w.getAttribute('data-parallax')) || 0.1;
        var off = (vh / 2 - (r.top + r.height / 2)) * amt;
        w.style.transform = 'translateX(-50%) translate3d(0,' + off.toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    frame();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  /* ─────────── TALLAS ─────────── */
  function initSizes() {
    document.addEventListener('click', function (e) {
      var chip = e.target.closest ? e.target.closest('[data-size]') : null;
      if (!chip || chip.disabled) return;
      var card = chip.closest('[data-card]');
      if (!card) return;
      $$('[data-size]', card).forEach(function (c) { c.classList.remove('is-on'); });
      chip.classList.add('is-on');
      var cta = $('[data-add]', card);
      if (cta) {
        cta.setAttribute('data-variant', chip.getAttribute('data-variant'));
        cta.disabled = false;
      }
    });
  }

  /* ─────────── CARRITO ─────────── */
  var drawer, scrim, body, sum, count;

  function ensureDrawer() {
    if (drawer) return;
    scrim = document.createElement('div');
    scrim.className = 'mrh-scrim';
    scrim.setAttribute('hidden', '');
    drawer = document.createElement('aside');
    drawer.className = 'mrh mrh-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', 'Tu carrito');
    drawer.innerHTML =
      '<div class="mrh-drawer__top"><h2>Tu carrito</h2>' +
      '<button class="mrh-drawer__x" data-close aria-label="Cerrar carrito">✕</button></div>' +
      '<div class="mrh-drawer__body" data-lines></div>' +
      '<div class="mrh-drawer__foot">' +
      '<div class="mrh-drawer__sum"><span>Total</span><b data-total>$0.00</b></div>' +
      '<p class="mrh-drawer__note">🚚 Envío gratis a todo Ecuador</p>' +
      '<a class="mrh-btn" href="/checkout">Ir a pagar</a>' +
      '<a class="mrh-drawer__link" href="/cart">Ver el carrito completo</a>' +
      '</div>';
    document.body.appendChild(scrim);
    document.body.appendChild(drawer);
    body = $('[data-lines]', drawer);
    sum = $('[data-total]', drawer);
    scrim.addEventListener('click', closeCart);
    $('[data-close]', drawer).addEventListener('click', closeCart);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeCart();
    });
    body.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-line-act]') : null;
      if (!b) return;
      changeLine(b.getAttribute('data-key'), parseInt(b.getAttribute('data-qty'), 10));
    });
  }

  function openCart() {
    ensureDrawer();
    scrim.removeAttribute('hidden');
    /* el rAF es solo para que la transición arranque desde el estado cerrado;
       si el navegador no lo llama (pestaña en segundo plano) igual se abre */
    var abrir = function () {
      scrim.classList.add('is-open');
      drawer.classList.add('is-open');
    };
    requestAnimationFrame(abrir);
    setTimeout(abrir, 120);
    document.documentElement.style.overflow = 'hidden';
    var x = $('[data-close]', drawer); if (x) x.focus();
  }
  function closeCart() {
    if (!drawer) return;
    scrim.classList.remove('is-open');
    drawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { if (!scrim.classList.contains('is-open')) scrim.setAttribute('hidden', ''); }, 240);
  }

  function render(cart) {
    ensureDrawer();
    if (!cart.items || !cart.items.length) {
      body.innerHTML = '<p class="mrh-drawer__empty">Tu carrito está vacío 🛒</p>';
    } else {
      body.innerHTML = cart.items.map(function (it) {
        var img = it.image ? it.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_160x$1$2') : '';
        var vari = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="mrh-line__v">' + it.variant_title + '</div>' : '';
        return '<div class="mrh-line">' +
          '<img src="' + img + '" alt="" loading="lazy">' +
          '<div><a class="mrh-line__t" href="' + it.url + '">' + it.product_title + '</a>' + vari +
          '<div class="mrh-line__foot"><div class="mrh-qty">' +
          '<button data-line-act data-key="' + it.key + '" data-qty="' + (it.quantity - 1) + '" aria-label="Quitar uno">−</button>' +
          '<span>' + it.quantity + '</span>' +
          '<button data-line-act data-key="' + it.key + '" data-qty="' + (it.quantity + 1) + '" aria-label="Añadir uno">+</button>' +
          '</div><span class="mrh-line__p">' + money(it.line_price) + '</span></div></div></div>';
      }).join('');
    }
    if (sum) sum.textContent = money(cart.total_price);
    setCount(cart.item_count);
  }

  function setCount(n) {
    count = count || $('[data-cart-count]');
    if (!count) return;
    count.textContent = n;
    count.classList.toggle('is-on', n > 0);
  }

  function refresh(open) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('No pudimos leer tu carrito');
        return r.json();
      })
      .then(function (c) { render(c); if (open) openCart(); return c; })
      .catch(function (err) { toast(err.message || 'No pudimos leer tu carrito'); });
  }

  /* ☠️ Sin mirar `res.ok` esto pintaba "Tu carrito está vacío": cuando Shopify
     contesta 422 —subir la cantidad por encima del stock— el cuerpo NO trae
     `items` y `render()` lo leía como carrito vacío. El cliente creía que había
     perdido todo. Ahora se dice el motivo y se repinta el carrito REAL. */
  function changeLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    }).then(function (r) {
      /* `text()` y no `json()`: un 5xx puede devolver HTML y ahí `json()` revienta
         con un error de parseo que no le dice nada a nadie */
      return r.text().then(function (txt) {
        var data = {};
        try { data = JSON.parse(txt); } catch (e) {}
        if (!r.ok) throw new Error(data.description || data.message || 'No se pudo cambiar la cantidad');
        return data;
      });
    }).then(render).catch(function (err) {
      toast(err.message || 'No se pudo cambiar la cantidad');
      return refresh(false);
    });
  }

  function initCart() {
    document.addEventListener('click', function (e) {
      var open = e.target.closest ? e.target.closest('[data-open-cart]') : null;
      if (open) { e.preventDefault(); refresh(true); return; }

      var btn = e.target.closest ? e.target.closest('[data-add]') : null;
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var id = btn.getAttribute('data-variant');
      if (!id) { toast('Elige una talla primero 👆'); return; }
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Añadiendo…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw new Error(err.description || 'No se pudo añadir'); });
        return r.json();
      }).then(function () {
        toast('🛒 Añadido al carrito');
        return refresh(true);
      }).catch(function (err) {
        toast(err.message || 'No se pudo añadir. Escríbenos por WhatsApp 📲');
      }).then(function () {
        btn.disabled = false;
        btn.textContent = label;
      });
    });

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); })
      .catch(function () {});
  }

  var booted = false;
  function boot() {
    $$('[data-mrh-hero]').forEach(initHero);
    initMotion();
    /* initSizes/initCart cuelgan un listener de clic del `document`. `boot()`
       se vuelve a llamar con cada `shopify:section:load`, así que sin esta
       guardia un solo clic terminaba añadiendo N veces al carrito. */
    if (booted) return;
    booted = true;
    initSizes();
    initCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
